import { combineReducers } from "redux";
import {
  fetching,
  submitting,
  items,
  togglable,
  selectable,
} from "./resource";

export default combineReducers({
  selectedItem: selectable("Windows"),
  isFetching: fetching("Windows"),
  isSubmitting: submitting("Windows"),
  items: items("Windows"),
  showAddModal: togglable("addModal"),
});
